import Avatar from "~/components/elements/Avatar";
import { getFullName } from "~/lib/name";
import Tippy from "@tippyjs/react";
import { StorageBucket, constructStorageUrl } from "~/lib/storage";

interface Contributors {
  contributors: any;
  maxFaces?: number;
  moreText?: boolean;
}

export default function Contributors({
  contributors,
  maxFaces = 5,
  moreText = true,
}: Contributors) {
  const maxDisplayedContributors = maxFaces;

  // Separate contributors into those with IDs and those without
  const newContributors =
    contributors
      ?.filter((contributor) => contributor.id)
      .sort((a, b) => a.order - b.order) || [];
  const legacyContributors =
    contributors?.filter((contributor) => !contributor.id) || [];

  // Compute number of contributors to be hidden behind "+"
  const moreContributorsCount =
    newContributors.length > maxDisplayedContributors
      ? newContributors.length -
        maxDisplayedContributors +
        legacyContributors.length
      : legacyContributors.length;

  return (
    <div className="relative flex">
      {newContributors?.length > 0 ? (
        <>
          {newContributors
            .slice(0, maxDisplayedContributors)
            .map((contributor, index) => (
              <Tippy
                key={contributor.id || index}
                content={`${contributor.first_name} ${contributor.last_name}`}
                theme="base"
              >
                <div
                  className={`-ml-${index > 0 ? 2 : 0}`}
                  title={`${contributor.first_name} ${contributor.last_name}`}
                >
                  {contributor.avatar ? (
                    <div className="rounded-full">
                      <Avatar
                        imageUrl={constructStorageUrl({
                          type: StorageBucket.Users,
                          userId: contributor.id,
                          avatarFileName: contributor.avatar,
                        })}
                        label={getFullName(
                          contributor.first_name,
                          contributor.last_name
                        )}
                        size={8}
                        resolution={64}
                      />
                    </div>
                  ) : (
                    <div
                      className={`flex h-8 w-8 items-center justify-center rounded-full bg-gray-200`}
                    >
                      <span className="text-xs font-semibold text-gray-500">
                        {contributor?.first_name?.charAt(0).toUpperCase()}
                        {contributor?.last_name?.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  )}
                </div>
              </Tippy>
            ))}
          {moreContributorsCount > 0 && (
            <div
              className={`ml-2 flex items-center justify-center text-xs font-semibold text-gray-500`}
            >
              {`+ ${moreContributorsCount} ${moreText ? "more" : ""}`}
            </div>
          )}
        </>
      ) : null}
    </div>
  );
}
